import React, { useContext, useState } from "react";
import {
  styled,
  /*Flex, $neutralColors,*/ $error
} from "@acko-tech/building-blocks.ui.common";
// import { Text } from "@acko-tech/building-blocks.ui.typography";
import InputField from "@components/common/mobile/inputField";
// import LazyLoadSvg from "@components/common/standAlone/lazyLoadSvg";

import Context from "@components/useContext/context";
import ChevronDown from "@public/images/chevron-down.svg";
import FIELD_ERROR_MESSAGE from "@utils/errorMessages";
interface StyleProps {
  error: boolean;
}

interface ComponentProps {
  children: string;
  selectedValue: string;
  icon: string;
  error: boolean;
  handleClick: Function;
  name: string;
  note?: string;
}

// const Wrapper = styled.div`
//   padding-bottom: 0.75em;
//   border-bottom: 0.5px solid ${$neutralColors.lightest};
// `;

const StyledChevronDown = styled(ChevronDown)<StyleProps>`
  & path {
    stroke: ${(props: any) => (props.error === "true" ? $error : ``)};
  }
  // align-self: flex-end;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 22px;
`;

// const Div = styled.div`
//   display: flex;
//   padding-bottom: 0.375em;
// `;

// const StyledLazyLoad = styled(LazyLoadSvg)<StyleProps>`
//   ${(props: any) =>
//     props.error
//       ? `& path {stroke: ${$error}}; & rect {stroke: ${$error}};& g {stroke: ${$error}};`
//       : ``}
// `;

export default function MmvDetails(props: ComponentProps): JSX.Element {
  const {
    /*icon,*/ error,
    selectedValue,
    children,
    handleClick,
    name,
    note
  } = props;
  // const displayContent = selectedValue !== "" ? selectedValue : children;
  const { isDesktop } = useContext(Context);
  const [touched, setTouched] = useState(false);
  // return (
  //   <Wrapper onClick={handleClick}>
  //     <Flex mt="0.75em">
  //       <Flex width="15%" justifyContent="center">
  //         <StyledLazyLoad icon={icon} error={error} />
  //       </Flex>
  //       <Flex
  //         pl="1em"
  //         pr="0.75em"
  //         justifyContent="space-between"
  //         alignItems="flex-end"
  //       >
  //         <Text size="xxs" colorVariant={error ? "error" : "hyperlink"}>
  //           {displayContent}
  //         </Text>
  //         <Div>
  //           <StyledChevronDown error={error ? "true" : "false"} />
  //         </Div>
  //       </Flex>
  //     </Flex>
  //   </Wrapper>
  // );

  return (
    <InputField
      name={name}
      style={{ width: "100px" }}
      handleClick={e => handleClick(e)}
      placeholder={children}
      value={selectedValue}
      // errors={{}}
      inputStyles={{
        // border: ((touched && error) || error) && `1px solid ${$error}`,
        caretColor: "transparent",
        height: isDesktop ? "48px" : ""
      }}
      handleBlur={() => setTouched(true)}
      readOnly={true}
      hideLabelText={error}
      inputContainerStyles={{ margin: "0px", height: "50px" }}
      showError={(touched && error) || error}
      errors={{ [name]: FIELD_ERROR_MESSAGE[name]?.required }}
      touched={{}}
      Icon={<StyledChevronDown onClick={handleClick} />}
      pb={true}
      note={note}
    />
  );
}
